import styled from 'styled-components'
import { Spin } from 'antd'

const AntSpinStyled = styled(Spin)`
  &&& {
    color: ${props => props.theme.colors.color1.bg};
    .ant-spin-dot {
      i {
        background-color: ${props => props.theme.colors.color1.bg};
      }
    }
  }
`

export default AntSpinStyled
